export default "__VITE_ASSET__ByCnonzY__"